import { render, staticRenderFns } from "./board_edit.vue?vue&type=template&id=8c3d7f66&scoped=true&"
import script from "./board_edit.vue?vue&type=script&lang=js&"
export * from "./board_edit.vue?vue&type=script&lang=js&"
import style0 from "./board_edit.vue?vue&type=style&index=0&id=8c3d7f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3d7f66",
  null
  
)

export default component.exports